import { render, staticRenderFns } from "./Period.edit.vue?vue&type=template&id=48dbd12e&scoped=true&"
import script from "./Period.edit.vue?vue&type=script&lang=js&"
export * from "./Period.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dbd12e",
  null
  
)

export default component.exports